import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5c59049b = () => interopDefault(import('../pages/diff.vue' /* webpackChunkName: "pages/diff" */))
const _85df27d6 = () => interopDefault(import('../pages/v2/index.vue' /* webpackChunkName: "pages/v2/index" */))
const _0d8417f3 = () => interopDefault(import('../pages/v1/diff.vue' /* webpackChunkName: "pages/v1/diff" */))
const _01cd8912 = () => interopDefault(import('../pages/v2/diff.vue' /* webpackChunkName: "pages/v2/diff" */))
const _98173ca8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/diff",
    component: _5c59049b,
    name: "diff"
  }, {
    path: "/v2",
    component: _85df27d6,
    name: "v2"
  }, {
    path: "/v1/diff",
    component: _0d8417f3,
    name: "v1-diff"
  }, {
    path: "/v2/diff",
    component: _01cd8912,
    name: "v2-diff"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
